import { useState } from "react";
import { demoPay } from "../api/endpoints";
import Sheet from "./Sheet";
import { notifyError } from "../lib/ui";
import type { Order, Product, Receipt } from "../types";

// Демо-платёжка: имитация оплаты (когда платёжный провайдер не настроен).
export function PaymentSheet({
  order, product, onPaid, onClose,
}: {
  order: Order;
  product: Product;
  onPaid: (r: Receipt) => void;
  onClose: () => void;
}) {
  const [busy, setBusy] = useState(false);
  const amount = Math.round(order.amount).toLocaleString("ru-RU");

  const pay = async () => {
    setBusy(true);
    try {
      onPaid(await demoPay(order.id));
    } catch (e) {
      notifyError(e);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Sheet open title="Оплата заказа" onClose={onClose}>
      <p style={{ margin: "0 0 16px", fontSize: 14, color: "var(--hint)" }}>
        {product.title ?? product.sku} · #{product.sku}
      </p>

      <div style={{ textAlign: "center", margin: "8px 0 18px" }}>
        <div style={{ fontSize: 34, fontWeight: 700, color: "var(--accent)", fontFamily: "var(--font-display)" }}>
          {amount} ₽
        </div>
      </div>

      {/* Имитация платёжной формы. */}
      <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 14px", background: "var(--secondary-bg)", borderRadius: 12, marginBottom: 10 }}>
        <span style={{ fontSize: 20 }}>💳</span>
        <span style={{ fontSize: 15, letterSpacing: 1 }}>•••• •••• •••• 4242</span>
        <span style={{ marginLeft: "auto", fontSize: 13, color: "var(--hint)" }}>12/29</span>
      </div>
      <p style={{ margin: "0 0 16px", fontSize: 12, color: "var(--hint)", textAlign: "center" }}>
        🧪 Демо-режим: реальная оплата не списывается. В проде здесь — Telegram Payments.
      </p>

      <button className="btn" onClick={pay} disabled={busy}>
        {busy ? "Оплата…" : `Оплатить ${amount} ₽`}
      </button>
      <div style={{ height: 8 }} />
      <button className="btn btn--secondary" onClick={onClose} disabled={busy}>Отмена</button>
    </Sheet>
  );
}
